<div [className]="'itb-search-widget'">
  <div class="search-widget-header">
    <div class="left">
        <itb-heading [className]="headingClassName" [text]="headingText"></itb-heading> &nbsp;
        <itb-text [className]="textClassName" [text]="'('+searchedItems+' '+text +')'"></itb-text>
    </div>
    <div class="right">
        <itb-icon [tooltipText]="'search'" [className]="'search'" (click)="searchIconClicked()"  *ngIf="hasSearchIcon"></itb-icon>    
        <itb-spinner [spinnerType]="'s'" *ngIf="hasLoader"></itb-spinner>
    </div>
    
  </div>
  <itb-divider [className]="'mat-divider'"></itb-divider>
  <div class="search-item-list-cont">
          <ng-content></ng-content>
  </div>
</div>